/** @format **/

import { Global } from '../types';

export const global: Global = (window as unknown) as Global;
